<div class="type-container">
	<span class="select-label"> {{ 'type' | translate }} </span>

	<div>
		<span
			class="choose-type-btn cursor-pointer"
			matRipple
			[matMenuTriggerFor]="documentTypeList"
		>
			@if (documentType) {
				<au-document-type [type]="documentType" />
			}

			@if (!documentType) {
				{{ 'choose' | translate }}
			}

			<mat-icon>arrow_drop_down</mat-icon>
		</span>
	</div>
</div>

<mat-menu #documentTypeList>
	<div class="menu-wrapper">
		@for (type of documentTypes; track type) {
			<div class="cursor-pointer" (click)="typeChanged.emit(type)">
				<au-document-type [type]="type" />
			</div>
		}
	</div>
</mat-menu>
